import { appNameProjectId } from "./Constants/ProductIds";

/**
 * Validator for app forms
 * @author Isabel Sprengers
 * @version 1.0
 * @see Used in component: AppStepper
 */
export function FormValidate(form, configuration, formName, isRootExist) {
  const configcheck = configuration === "full" || configuration === "" ? true : false;
  const general =
    form.WBSEcode === "" ||
    form.AdminDistributionGroup === "" ||
    form.SecondaryPOC === "";

  const genralNoDeployRegion =
    configcheck ? form.Environment === "" ||
      form.SAPContractID === "" ||
      form.UsersDistributionGroup === ""
      : false;

  const atrValid =
    form.WBSEcode === "" ||
    form.SecondaryPOC === "";

  const turingValid =
    form.WBSEcode === "" ||
    form.SuperAdminDistributionGroup === "" ||
    form.SecondaryPOC === "";

  const atrSaaSValid =
    form.ClientName === "" ||
    form.DomainContextRoot === "no" ||
    form.DryRun === "" ||
    form.DeploymentRegion === "";

  const generalFormValid =
    // configuration === "full"
    configcheck
      ? form.UsersDistributionGroup === ""
      : false;

  const atrEnvTierValid =
    form.Environment === "Production" ?
      form.Tier === ""
      : false;

  const atrEmbeddingsModelValid =
    form.OpenAI === "OpenAI+Quasar" ?
      form.OpenAITextEmbeddingsModel === "" ||
      form.SuperAdminDistributionGroup === ""
      : false;

  const genwizardEnvDBTypeValid =
    form.Environment === "Production" ?
      form.DBType === ""
      : false;

  const genwizardADValid =
    form.AppsIntegration != 0 ?
      form.AdminDistributionGroup === ""
      : false;

  const taFormValid = form.TicketFeed === "" || form.TicketMonthlyVolume === "";

  const ritmFieldValid =
    configcheck ? form.RITM === "" : false;

  const ritmFieldValidBothOptions =
    form.RITM === "";

  const automationAnywhereValid =
    form.InstanceType === "" ||
    form.AAversion === "" ||
    form.NumOfControlRoomlicenses === "" ||
    form.NumOfRunnerlicenses === "" ||
    form.NumOfDeveloperlicenses === "" ||
    form.RequestNotes === "" ||
    form.LicenseUsage === "";

  const automationAnywhereLicensesValid =
    parseInt(form.NumOfControlRoomlicenses, 10) +
    parseInt(form.NumOfRunnerlicenses, 10) +
    parseInt(form.NumOfDeveloperlicenses, 10) <=
    0;

  const onPremiseServiceValid =
    form.DeploymentRegion === "" ||
    form.Environment === "" ||
    form.TentativeServiceEndDate === "" ||
    form.DailyDataVolume === "" ||
    form.InfrastructureType === "" ||
    form.LicensePurpose === "";

  const generalLicense =
    // form.DMSId === "" ||
    form.WBSEcode === "";

  const onPremLicensePurposeValid =
    form.LicensePurpose === "AiOps Asset" ?
      form.AiOpsAsset == []
      : false;

  const projectNameCheck =
    form.ProjectName === "";

  const onPremFullPlatform =
    // configuration === "full"
    configcheck
      ? form.Environment === "" ||
      form.SAPContractID === "" ||
      // form.EndToEndUId === "" ||
      form.SecondaryPOC === ""
      : false;

  const generalPlatform =
    form.DomainContextRoot === "" ||
    form.DeploymentRegion === "" ||
    form.Environment === "" ||
    form.TentativeServiceEndDate === "" ||
    // form.SAPContractID === "" ||
    // form.EndToEndUId === "" ||
    form.RequestNotes === "" ||
    isRootExist;

  const dcrCheckEventOps = configcheck ? form.DomainContextRoot === "" : false;

  const meshandcia =
    form.SAPContractID === "" ||
    form.WBSEcode === "" ||
    form.Environment === "" ||
    form.TentativeServiceEndDate === "" ||
    form.DomainContextRoot === "" ||
    form.AdminDistributionGroup === "" ||
    form.SecondaryPOC === "" ||
    form.ProjectName === "";
    
  const dedicatedvirtualnetworksetup =
    form.SAPContractID === "" ||
    form.WBSEcode === "" ||
    form.Environment === "" ||
    form.TentativeServiceEndDate === "" ||
    form.DomainContextRoot === "" ||
    form.AdminDistributionGroup === "" ||
    form.SecondaryPOC === "" ||
    form.ProjectName === "";

  const generalEventOpsPlatform =
    // form.DomainContextRoot === "" ||
    form.DeploymentRegion === "" ||
    form.Environment === "" ||
    form.TentativeServiceEndDate === "" ||
    // form.SAPContractID === "" ||
    // form.EndToEndUId === "" ||
    form.RequestNotes === "" ||
    isRootExist;

  const pamInstancePlatform =
    // form.ClientName === "" ||
    // form.SAPContractID === "" ||
    // form.EndToEndUId === "" ||
    form.DeploymentRegion === "" ||
    form.PAMPlatformType === "" ||
    form.Tier === "" ||
    form.RequestNotes === "" ||
    form.SecondaryPOC === "" ||
    (form.PAMApps &&
      form.PAMApps.length === 0 &&
      form.PAMPlatformType === "PAM Premium");

  const generalFullPlatform =
    // configuration === "full"
    configcheck
      ? form.Environment === "" ||
      form.SAPContractID === ""
      : false;

  const pamFullPlatform =
    // configuration === "full"
    configcheck
      ? form.Environment === "" ||
      form.SAPContractID === "" ||
      // form.EndToEndUId === "" ||
      form.SecondaryPOC === ""
      : false;
  const BedrockPlatform =
    form.SAPContractID === "" ||
    form.WBSEcode === "" ||
    form.Environment === "" ||
    form.SecondaryPOC === "" ||
    form.ProjectName === "";
  
  const KnowledgeManger =
    form.SAPContractID === "" ||
    form.WBSEcode === "" ||
    form.Environment === "" ||
    form.TentativeServiceEndDate === "" ||
    form.DomainContextRoot === "" ||
    form.AdminDistributionGroup === "" ||
    form.SecondaryPOC === "" ||
    form.SuperAdminDistributionGroup === "" ||
    form.ProjectName === "" ||
    form.RequestNotes === "" ||
    isRootExist;

  const generalAtrFullPlatform =
    // configuration === "full"
    configcheck
      ? form.Environment === "" ||
      form.SAPContractID === ""
      : false;

  const generalEventOpsFullPlatform =
    // configuration === "full"
    configcheck
      ? form.Environment === "" ||
      form.SAPContractID === ""
      : false;

  const generalTuringFullPlatform =
    // configuration === "full"
    configcheck
      ?
      form.Environment === "" ||
      form.SAPContractID === ""
      : false;

  const openAICheck =
    form.OpenAI === "True" || form.EnableQuasar === "True" ?
      form.ChatGPT === "" ||
      form.SuperAdminDistributionGroup === ""
      : false;

  const superAdminCheck =
    form.KMApps === "KlewerGenAi-QuasarGenAi-Quasarpp" ?
      form.SuperAdminDistributionGroup === ""
      : false;

  const teamNameCheck =
    form.TeamName === "" ||
    form.TeamName === null;

  const dataClassifyCheck =
    form.DataClassification === "";
  
  const teamNameOthersCheck =
    form.TeamName === "Others" ?
      form.TeamNameOthers === "" :
      false;

  const qppVersionCheck = 
      form.QppVersion === "";

  const qppDropdownCheck =
      form.Quasarpp === "";    

  const isPocvalid=
      form.pocdetails === "" ||
      form.SAPContractID === "0000000000" &&
      form.RITM === "";

  const platformValid =
    generalFormValid || general || generalPlatform || generalFullPlatform;
  switch (formName) {
    case "TicketAnalysis":
      return taFormValid || generalFormValid || general || projectNameCheck || teamNameCheck || teamNameOthersCheck || isPocvalid;
    //Fall-through
    case "DedicatedPlatform":
    case "WindowsProvisioningPlatform":
    case "SplunkClusterPlatform":
    case "ServiceIntegrator":
      return generalFormValid || general || generalPlatform || generalFullPlatform || projectNameCheck || teamNameCheck || teamNameOthersCheck || dataClassifyCheck || isPocvalid;
      
    case "Stack360":
    case "ManagedPlatform":
      return form["appProductUId"].includes(appNameProjectId.ticketAnalysisId)
        ? platformValid || taFormValid || projectNameCheck || teamNameCheck || teamNameOthersCheck
        : platformValid || projectNameCheck || teamNameCheck || teamNameOthersCheck || dataClassifyCheck;

    case "GenWizardPlatform":
      return generalPlatform || general || genralNoDeployRegion || genwizardADValid || projectNameCheck || openAICheck || teamNameCheck || dataClassifyCheck || teamNameOthersCheck || qppVersionCheck || isPocvalid;

    case "ADPlatform":
      return generalPlatform || general || genralNoDeployRegion || projectNameCheck || teamNameCheck || dataClassifyCheck || teamNameOthersCheck || isPocvalid;

    case "AutomaticTicketResolverSaaS":
      return atrValid || atrSaaSValid || projectNameCheck || teamNameCheck || teamNameOthersCheck;

    case "AutomaticTicketResolver":
      return atrValid || general || generalPlatform || generalAtrFullPlatform || atrEnvTierValid || projectNameCheck || atrEmbeddingsModelValid || openAICheck || teamNameCheck || dataClassifyCheck || teamNameOthersCheck || isPocvalid;

    case "EventOps":
      return atrValid || dcrCheckEventOps || generalEventOpsPlatform || generalEventOpsFullPlatform || projectNameCheck || general || isPocvalid;

    case "Turing":
      return turingValid || general || generalPlatform || generalTuringFullPlatform || atrEnvTierValid || projectNameCheck || teamNameCheck || dataClassifyCheck || teamNameOthersCheck || isPocvalid;
    case "GenwizardAgent":
    case "ReverseEngineering":
      return general || generalPlatform || generalTuringFullPlatform || projectNameCheck || teamNameCheck || dataClassifyCheck || teamNameOthersCheck || isPocvalid;

    case "StormSeer":
      return atrValid || generalPlatform || generalAtrFullPlatform || projectNameCheck || teamNameCheck || teamNameOthersCheck || dataClassifyCheck;

    case "PlainInstance":
    case "Ec2ClaudeCode":
      return (
        generalFormValid || general || generalPlatform || generalFullPlatform || projectNameCheck || teamNameCheck || dataClassifyCheck || teamNameOthersCheck || isPocvalid
      );
    case "AutomationAnywhereLicenses":
      return (
        generalLicense ||
        automationAnywhereValid ||
        automationAnywhereLicensesValid || projectNameCheck || teamNameCheck || teamNameOthersCheck || isPocvalid
      );
    case "OnPremiseService":
      return generalLicense || onPremiseServiceValid || onPremFullPlatform || onPremLicensePurposeValid || projectNameCheck || teamNameCheck || dataClassifyCheck || teamNameOthersCheck || isPocvalid;
    case "PamInstance":
      return pamInstancePlatform || pamFullPlatform || projectNameCheck || teamNameCheck || dataClassifyCheck || teamNameOthersCheck || isPocvalid;
    case "UTKMPlatform":
      return general || generalPlatform || pamFullPlatform || projectNameCheck || superAdminCheck || teamNameCheck || dataClassifyCheck || teamNameOthersCheck || isPocvalid || qppDropdownCheck;
    case "AgentMesh":
    case "CIA":
      return meshandcia;
    case "BedrockPlatform":
      return BedrockPlatform;
    case "DedicatedVirtualNetworkSetup":
      return dedicatedvirtualnetworksetup;
    default:
      return generalFormValid || general || projectNameCheck;
  }
}
